<!-- src/App.vue -->
<template>
<div class="app-background">
  <div id="app">
    <!-- 固定在頂部的導航欄，居中對齊 -->
    <div class="fixed-navbar">
      <div class="container">
        <navbar />
      </div>
    </div>
    
    <!-- 主要內容區域，考慮到固定導航欄的高度 -->
    <div class="main-content">
      <div class="container">
        <div class="row">
          <!-- 左側區域：固定的Playerhc和播放列表 -->
          <div class="col-md-6 col-12 left-column">
            <div class="video-wrapper">
              <Playerhc />
            </div>
            
            <div class="playlist-wrapper" v-show="!isLoginModalVisible">
              <testpinia/>
            </div>
          </div> 

          <!-- 右側區域：可滾動的router-view -->
          <div class="col-md-6 col-12 scrollable-content">
            <router-view :key="$route.fullPath" />
          </div>
           
        </div>  
      </div>
    </div>
    
    <!-- Cookie 同意提示 -->
    <!-- <CookieConsent /> -->
    <!-- <InstallPrompt /> -->

    <!-- 在開發模式下添加一個清除緩存按鈕 -->
    <div v-if="isDev" class="dev-tools">
      <button @click="clearCache" class="btn btn-sm btn-warning">清除 PWA 緩存</button>
    </div>
    
    <!-- 客服懸浮球 -->
    <ChatBubble />
  </div>
</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';  
import navbar from './components/navbar.vue';
import Playerhc from './components/Playerhc.vue';
import testpinia from './components/testpinia.vue';
// import CookieConsent from './components/CookieConsent.vue';
import { useUserStore } from './store/useUserStore';
import axios from 'axios';
// import InstallPrompt from './components/InstallPrompt.vue'
import LineBinding from './components/LineBinding.vue';
import ChatBubble from './components/ChatBubble.vue';

const route = useRoute();

// 動態設置 publicUrl，檢測是否通過主系統的 /ordersong/ 路徑訪問
const isOrdersongPath = window.location.pathname.startsWith('/ordersong/');
const publicUrl = isOrdersongPath ? '' : (import.meta.env.VITE_PUBLIC_URL || 'https://localhost');

const song = ref(null);

const userStore = useUserStore();
let balanceUpdateInterval = null;

// 監聽登入模態框的顯示狀態
const isLoginModalVisible = ref(false);

// 防止重複執行的標記
let isProcessingGoogleOAuth = false;

// 檢測 WebView 並顯示提示
const checkWebViewAndAlert = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  console.log('🔍 User Agent:', ua);
  
  let isWebView = false;
  let appName = '';
  
  // 檢測 LINE 內建瀏覽器
  if (ua.includes('Line/') || ua.includes('LINE/')) {
    isWebView = true;
    appName = 'LINE';
    console.log('✅ 檢測到 LINE 瀏覽器');
  }
  /*
  // 檢測 Facebook 內建瀏覽器
  else if (ua.includes('FBAN') || ua.includes('FBAV') || ua.includes('FB_IAB')) {
    isWebView = true;
    appName = 'Facebook';
    console.log('✅ 檢測到 Facebook 瀏覽器');
  }
  // 檢測 Instagram 內建瀏覽器
  else if (ua.includes('Instagram')) {
    isWebView = true;
    appName = 'Instagram';
    console.log('✅ 檢測到 Instagram 瀏覽器');
  }
  // 檢測一般 WebView (Android)
  else if (ua.includes('wv') && ua.includes('Android')) {
    isWebView = true;
    appName = 'App';
    console.log('✅ 檢測到 Android WebView');
  }
  */
  else {
    console.log('ℹ️ 未檢測到 WebView，使用標準瀏覽器');
  }
  
  if (isWebView) {
    console.log(`📱 顯示 ${appName} WebView 提示（建議切換外部瀏覽器）`);
    showWebViewAlert(appName);
  }
};

// 顯示 WebView 提示並嘗試打開外部瀏覽器
const showWebViewAlert = (appName) => {
  console.log(`🎨 顯示 ${appName} WebView 提示並嘗試打開外部瀏覽器`);
  
  const currentUrl = window.location.href;
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  
  // 嘗試打開外部瀏覽器的函數
  const openInExternalBrowser = () => {
    try {
      if (isAndroid) {
        // Android: 使用 intent:// URL scheme
        const urlWithoutProtocol = currentUrl.replace(/^https?:\/\//, '');
        const intentUrl = `intent://${urlWithoutProtocol}#Intent;scheme=https;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end`;
        console.log('嘗試使用 Android Intent 打開外部瀏覽器:', intentUrl);
        
        // 先嘗試 intent
        window.location.href = intentUrl;
        
        // 如果 intent 失敗，嘗試直接打開
        setTimeout(() => {
          try {
            window.open(currentUrl, '_system');
          } catch (e) {
            console.log('嘗試使用 _system 打開失敗，使用 _blank');
            window.open(currentUrl, '_blank');
          }
        }, 500);
      } else if (isIOS) {
        // iOS: LINE webview 無法自動打開外部瀏覽器，需要用戶手動操作
        // 不執行自動打開，只顯示提示
        console.log('iOS 環境：需要用戶手動在 LINE 中選擇「使用瀏覽器開啟」');
        return false; // 返回 false 表示不自動打開
      } else {
        // 其他平台：直接打開
        console.log('嘗試打開外部瀏覽器');
        window.open(currentUrl, '_blank');
      }
      return true;
    } catch (error) {
      console.error('打開外部瀏覽器失敗:', error);
      return false;
    }
  };
  
  const modalHTML = `
    <div id="webview-alert-modal" style="
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background-color: rgba(0, 0, 0, 0.85) !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      z-index: 9999999 !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
    ">
      <div style="
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        padding: 20px !important;
        border-radius: 15px !important;
        text-align: center !important;
        max-width: 280px !important;
        width: 90% !important;
        box-shadow: 0 20px 60px rgba(0,0,0,0.3) !important;
        position: relative !important;
      ">
        <button onclick="document.getElementById('webview-alert-modal').remove();" style="
          position: absolute !important;
          top: 10px !important;
          right: 10px !important;
          background: rgba(255,255,255,0.3) !important;
          border: none !important;
          border-radius: 50% !important;
          width: 30px !important;
          height: 30px !important;
          color: white !important;
          font-size: 20px !important;
          font-weight: bold !important;
          cursor: pointer !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: all 0.3s !important;
          line-height: 1 !important;
          padding: 0 !important;
        " onmouseover="this.style.background='rgba(255,255,255,0.5)'; this.style.transform='scale(1.1)'" onmouseout="this.style.background='rgba(255,255,255,0.3)'; this.style.transform='scale(1)'">
          ×
        </button>
        <div style="
          background: rgba(255,255,255,0.2) !important;
          border-radius: 10px !important;
          padding: 20px !important;
          text-align: center !important;
        ">
          <div style="
            color: white !important;
            font-size: 28px !important;
            margin-bottom: 12px !important;
          ">📱 ➡️ ⋯ ➡️ 🌐</div>
          <p style="
            margin: 0 !important;
            font-size: 14px !important;
            color: white !important;
            font-weight: 500 !important;
            line-height: 1.6 !important;
          ">點擊右下角三點 → 選擇瀏覽器開啟</p>
        </div>
      </div>
    </div>
  `;
  
  document.documentElement.insertAdjacentHTML('beforeend', modalHTML);
  console.log(`✅ WebView (${appName}) 提示模態框已顯示`);
  
  // 自動嘗試打開外部瀏覽器（僅 Android，iOS 需要用戶手動操作）
  if (!isIOS) {
    setTimeout(() => {
      openInExternalBrowser();
    }, 1000);
  }
};

// 更新餘額信息
const updateBalance = async () => {
  if (userStore.isLoggedIn && userStore.getCustomId) {
    try {
      const response = await axios.get(`/customer/${userStore.getCustomId}/balancepoints/`);
      userStore.updateBalance(response.data.balancepoints || 0);
    } catch (error) {
      console.error('更新餘額失敗:', error);
    }
  }
};

onMounted(() => {
  console.log('=== App.vue onMounted 開始執行 ===');
  console.log('當前 URL:', window.location.href);
  
  // 檢測 WebView 並顯示提示
  checkWebViewAndAlert();
  
  // 檢查 URL 參數中的 Google OAuth 登入信息
  console.log('即將調用 checkGoogleOAuthCallback...');
  checkGoogleOAuthCallback();
  console.log('checkGoogleOAuthCallback 調用完成');
  
  // 初始更新
  updateBalance();
  
  // 設置定期更新（每分鐘）
  balanceUpdateInterval = setInterval(updateBalance, 60000);

  // 檢查是否已經同意 Cookie
  const consent = localStorage.getItem('cookieConsent');
  if (!consent) {
    console.log('Cookie consent not found, showing banner');
  } else {
    console.log('Cookie consent already given');
  }

  // 監聽登入模態框狀態變化
  window.addEventListener('login-modal-show', () => {
    isLoginModalVisible.value = true;
  });
  
  window.addEventListener('login-modal-hide', () => {
    isLoginModalVisible.value = false;
  });
  
  // 不添加任何額外的檢查，只在 onMounted 中執行一次
});

// 檢查 Google OAuth 登入回調
const checkGoogleOAuthCallback = () => {
  // 防止重複執行
  if (isProcessingGoogleOAuth) {
    console.log('Google OAuth 正在處理中，跳過重複執行');
    return;
  }

  console.log('=== App.vue: 檢查 Google OAuth 登入回調參數 ===');
  console.log('當前 URL:', window.location.href);
  
  const urlParams = new URLSearchParams(window.location.search);
  const googleLogin = urlParams.get('google_login');
  const token = urlParams.get('token');
  const customer_id = urlParams.get('customer_id');
  const username = urlParams.get('username');
  const balancepoints = urlParams.get('balancepoints');
  const action = urlParams.get('action');
  const error = urlParams.get('error');
  
  console.log('App.vue: 解析的 URL 參數:', {
    googleLogin,
    token: token ? token.substring(0, 10) + '...' : null,
    customer_id,
    username,
    balancepoints,
    action,
    error
  });
  
  // 如果沒有相關參數，直接返回
  if (!googleLogin && !token && !customer_id && !username && !error) {
    console.log('App.vue: 沒有 Google OAuth 相關參數');
    return;
  }
  
  // 設置處理標記，但不立即清理 URL 參數（讓 setTimeout 有機會執行）
  isProcessingGoogleOAuth = true;
  console.log('App.vue: 設置處理標記，開始處理 Google OAuth');
  
  if (error) {
    console.error('App.vue: Google 登入錯誤:', error);
    alert(`Google 登入失敗: ${decodeURIComponent(error)}`);
    isProcessingGoogleOAuth = false;
    return;
  }
  
  if (googleLogin === 'success' && token && customer_id && username) {
    console.log('App.vue: 檢測到 Google OAuth 登入成功，開始自動設置用戶狀態');
    
    console.log('App.vue: userStore 當前狀態:', {
      isLoggedIn: userStore.isLoggedIn,
      customId: userStore.getCustomId,
      username: userStore.getUsername
    });
    
    // 設置用戶信息到 store
    const userData = {
      customer_id: customer_id,
      username: decodeURIComponent(username),
      balancepoints: parseInt(balancepoints) || 0,
      token: token
    };
    
    console.log('App.vue: 即將設置用戶數據:', userData);
    
    try {
      userStore.setUser(userData);
      console.log('App.vue: userStore.setUser() 調用成功');
      
      // 檢查設置後的狀態
      console.log('App.vue: 設置後的 userStore 狀態:', {
        isLoggedIn: userStore.isLoggedIn,
        customId: userStore.getCustomId,
        username: userStore.getUsername,
        balancepoints: userStore.getBalancePoints
      });
      
      // 觸發事件通知其他組件
      window.dispatchEvent(new CustomEvent('user-login', { 
        detail: userData 
      }));
      window.dispatchEvent(new CustomEvent('user-login-success', { 
        detail: userData 
      }));
      window.dispatchEvent(new CustomEvent('global-user-login', { 
        detail: userData 
      }));
      console.log('App.vue: 已觸發所有登入事件');
      
      // 檢查用戶是否需要 LINE 綁定
      console.log('App.vue: 檢查用戶 LINE 綁定狀態');
      
      // 註冊成功或登入成功都檢查 LINE 綁定狀態
      if (action === 'register') {
        console.log('App.vue: Google 註冊成功，歡迎新用戶');
        // 註冊用戶直接顯示 LINE 綁定
        setTimeout(() => {
          showLineBindingModal(customer_id, 'register');
        }, 1000);
      } else {
        console.log('App.vue: Google 登入成功');
        // 登入用戶檢查是否已綁定 LINE
        setTimeout(() => {
          checkLineBindingStatus(customer_id);
        }, 1000);
      }
      
      // 更新餘額
      updateBalance();
      
    } catch (error) {
      console.error('App.vue: 設置用戶狀態時發生錯誤:', error);
      alert('設置用戶狀態時發生錯誤');
    }
    
    // 處理完成後清理 URL 參數
    setTimeout(() => {
      console.log('App.vue: 清理 URL 參數');
      window.history.replaceState({}, document.title, window.location.pathname);
    }, 1000); // 延遲清理，確保 setTimeout 有機會執行
    
    console.log('=== App.vue: Google OAuth 自動登入處理完成 ===');
  } else {
    console.log('App.vue: 未檢測到有效的 Google OAuth 登入參數');
  }
  
  // 處理完成後重置標記
  setTimeout(() => {
    isProcessingGoogleOAuth = false;
  }, 2000); // 延長重置時間
};

onUnmounted(() => {
  // 清除定時器
  if (balanceUpdateInterval) {
    clearInterval(balanceUpdateInterval);
  }
});

const getYouTubeEmbedUrl = (url) => {
  const videoId = url.split('v=')[1];
  return `https://www.youtube.com/embed/${videoId}`;
};

const handleImageError = (e) => {
  e.target.src = '/default-album.jpg';
};

// 在開發模式下添加一個清除緩存按鈕
const isDev = import.meta.env.DEV;

const clearCache = async () => {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
    
    // 清除緩存
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
    }
    
    alert('PWA 緩存已清除，請刷新頁面');
    window.location.reload(true);
  }
};

// 顯示 Google 註冊成功訊息，包含 LINE QR Code
// 檢查 LINE 綁定狀態
const checkLineBindingStatus = async (customId) => {
  console.log('🔍 檢查用戶 LINE 綁定狀態，用戶 ID:', customId);
  
  try {
    const response = await axios.get(`/customer/${customId}/line-binding-status/`);
    console.log('LINE 綁定狀態響應:', response.data);
    
    if (!response.data.is_bound) {
      console.log('用戶未綁定 LINE，顯示綁定模態框');
      showLineBindingModal(customId, 'login');
    } else {
      console.log('用戶已綁定 LINE，無需顯示綁定框');
    }
  } catch (error) {
    console.error('檢查 LINE 綁定狀態失敗:', error);
    // 如果檢查失敗，預設顯示綁定框
    console.log('檢查失敗，預設顯示綁定框');
    showLineBindingModal(customId, 'login');
  }
};

// 顯示 LINE 綁定模態框
const showLineBindingModal = async (customId, actionType) => {
  console.log('🎉 顯示 LINE 綁定模態框，用戶 ID:', customId, '動作類型:', actionType);
  
  // 生成 5 位數綁定碼
  let bindingCode;
  try {
    const response = await axios.post(`/generate-line-binding-code/`, {
      customer_id: customId
    });
    bindingCode = response.data.binding_code;
    console.log('綁定碼生成成功:', bindingCode);
  } catch (error) {
    console.error('生成綁定碼失敗:', error);
    bindingCode = Math.floor(10000 + Math.random() * 90000).toString();
    console.log('使用備用綁定碼:', bindingCode);
  }
  
  // 使用正確的 LINE Bot QR Code URL
  const qrCodeUrl = `https://qr-official.line.me/sid/L/863izsuh.png`;
  
  // 先移除可能存在的舊模態框
  const existingModal = document.getElementById('line-binding-modal');
  if (existingModal) {
    console.log('移除現有模態框');
    existingModal.remove();
  }
  
  const title = actionType === 'register' ? '🎉 Google 註冊成功，歡迎！' : '🔗 綁定 LINE 帳號';
  const subtitle = actionType === 'register' ? 
    '綁定 LINE 可以使用生活大師所有功能' : 
    '綁定 LINE 獲得更好的服務體驗';
  
  // 創建簡化的模態框 HTML
  const modalHTML = `
    <div id="line-binding-modal" style="
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background-color: rgba(0, 0, 0, 0.8) !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      z-index: 999999 !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
    ">
      <div style="
        background: white !important;
        padding: 30px !important;
        border-radius: 15px !important;
        text-align: center !important;
        max-width: 400px !important;
        width: 85% !important;
        box-shadow: 0 15px 30px rgba(0,0,0,0.4) !important;
        position: relative !important;
        z-index: 1000000 !important;
        border: 2px solid #00C300 !important;
      ">
        <h2 style="color: #00C300 !important; margin-bottom: 20px !important; font-size: 22px !important; font-weight: bold !important;">🎉 LINE 綁定</h2>
        
        <div style="margin: 20px 0 !important; padding: 10px !important; border-radius: 8px !important;">
          <img src="${qrCodeUrl}" 
               alt="LINE QR Code" 
               style="max-width: 180px !important; height: auto !important; border: 2px solid #00C300 !important; border-radius: 10px !important; display: block !important; margin: 0 auto !important; background: white !important; padding: 8px !important;" 
               onload="console.log('LINE QR Code 圖片已載入')"
               onerror="console.error('LINE QR Code 圖片載入失敗'); this.style.display='none'; this.nextElementSibling.style.display='block';" />
          <div style="display: none; color: #666; font-size: 14px; margin-top: 10px;">
            圖片載入失敗，請搜尋 LINE ID: @863izsuh
          </div>
        </div>
        
        <div style="background: linear-gradient(135deg, #e8f5e8, #f0f8f0) !important; padding: 20px !important; border-radius: 12px !important; margin: 20px 0 !important; border: 2px solid #00C300 !important;">
          <div style="font-size: 42px !important; font-weight: bold !important; color: #00C300 !important; margin-bottom: 10px !important; font-family: monospace !important; letter-spacing: 3px !important; text-shadow: 2px 2px 4px rgba(0,195,0,0.3) !important;">
            ${bindingCode}
          </div>
          <p style="color: #2e7d32 !important; font-size: 16px !important; margin: 0 !important; font-weight: bold !important;">
            📱 綁定代碼
          </p>
        </div>
        
        <div style="background: #fff3cd !important; border: 1px solid #ffeaa7 !important; border-radius: 8px !important; padding: 15px !important; margin: 15px 0 !important;">
          <p style="color: #856404 !important; font-size: 14px !important; margin: 0 !important; line-height: 1.5 !important;">
            <strong>📋 綁定步驟：</strong><br>
            1️⃣ 掃描上方 QR Code 加好友<br>
            2️⃣ 在 LINE 中發送綁定代碼<br>
            3️⃣ 系統自動完成綁定
          </p>
        </div>
        
        <button onclick="console.log('稍後綁定按鈕被點擊'); document.getElementById('line-binding-modal').remove();" 
                style="
                  background: #f8f9fa !important;
                  color: #6c757d !important;
                  border: 1px solid #dee2e6 !important;
                  padding: 10px 25px !important;
                  border-radius: 20px !important;
                  cursor: pointer !important;
                  font-size: 14px !important;
                  transition: all 0.3s !important;
                  margin-top: 15px !important;
                "
                onmouseover="this.style.background='#e9ecef'; this.style.color='#495057'"
                onmouseout="this.style.background='#f8f9fa'; this.style.color='#6c757d'">
          稍後綁定
        </button>
      </div>
    </div>
  `;
  
  console.log('創建 LINE 綁定模態框 HTML');
  
  // 將模態框添加到頁面最高層
  document.documentElement.insertAdjacentHTML('beforeend', modalHTML);
  
  // 驗證模態框是否成功添加
  const modal = document.getElementById('line-binding-modal');
  if (modal) {
    console.log('✅ LINE 綁定模態框已成功添加到 DOM');
    
    // 啟動自動綁定狀態檢查輪詢
    const pollInterval = startBindingStatusPolling(customId);
    
    // 添加點擊背景關閉功能 - 只關閉模態框，保持後台綁定流程
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        console.log('點擊背景關閉模態框 - 保持後台綁定流程運行');
        modal.remove();
        // 不清除輪詢，讓綁定流程繼續在後台運行
        // 用戶仍然可以通過 LINE 完成綁定
      }
    });
    
    // 5分鐘後自動關閉模態框，但保持後台綁定流程
    setTimeout(() => {
      const modal = document.getElementById('line-binding-modal');
      if (modal) {
        console.log('自動關閉 LINE 綁定模態框 - 保持後台綁定流程運行');
        modal.remove();
        // 不清除輪詢，讓綁定流程繼續在後台運行
      }
    }, 300000); // 5分鐘
    
  } else {
    console.error('❌ LINE 綁定模態框添加失敗');
  }
};

// 檢查綁定完成狀態
const checkBindingComplete = async (customId) => {
  console.log('🔍 檢查綁定完成狀態，用戶 ID:', customId);
  
  try {
    const response = await axios.get(`/customer/${customId}/line-binding-status/`);
    console.log('綁定狀態檢查響應:', response.data);
    
    if (response.data.is_bound) {
      console.log('🎉 LINE 綁定成功！');
      alert('🎉 LINE 綁定成功！現在您可以使用完整的服務功能。');
    } else {
      console.log('⚠️ 尚未完成綁定');
      alert('⚠️ 尚未檢測到 LINE 綁定。請確保已加入好友。系統會在用戶加好友時自動完成綁定。');
    }
  } catch (error) {
    console.error('檢查綁定狀態失敗:', error);
    alert('⚠️ 無法檢查綁定狀態，請稍後再試。');
  }
};

// 開始輪詢檢查綁定狀態
const startBindingStatusPolling = (customId) => {
  console.log('🔄 開始輪詢檢查綁定狀態');
  
  let pollCount = 0;
  const maxPolls = 150; // 5分鐘（每2秒檢查一次）
  
  const pollInterval = setInterval(async () => {
    pollCount++;
    // console.log(`🔄 第 ${pollCount} 次檢查綁定狀態`);
    
    try {
      const response = await axios.get(`/customer/${customId}/line-binding-status/`);
      
      if (response.data.is_bound) {
        console.log('🎉 自動檢測到 LINE 綁定成功！');
        clearInterval(pollInterval);
        
        // 關閉模態框（如果還存在）
        const modal = document.getElementById('line-binding-modal');
        if (modal) {
          modal.remove();
          console.log('✅ 自動關閉 LINE 綁定模態框');
        }
        
        // 顯示成功訊息（無論模態框是否已關閉）
        alert('🎉 LINE 綁定成功！已自動完成綁定，現在您可以使用完整的服務功能。');
        return;
      }
    } catch (error) {
      console.error('輪詢檢查綁定狀態失敗:', error);
    }
    
    // 達到最大輪詢次數
    if (pollCount >= maxPolls) {
      console.log('⏰ 輪詢檢查已達到最大次數，停止檢查');
      clearInterval(pollInterval);
    }
  }, 2000); // 每2秒檢查一次
  
  return pollInterval;
};

// 全域函數供 HTML 使用
window.checkBindingComplete = checkBindingComplete;
</script>

<style>
.app-background {
  background-image: url(/23299312_m.jpg) !important;
  background-size: cover !important;
  background-position: center !important;
  background-attachment: fixed !important; /* 固定背景圖，不隨滾動而移動 */
  background-repeat: no-repeat !important;
  min-height: 100vh !important;
  width: 100% !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: -1 !important;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

/* 固定導航欄樣式 */
.fixed-navbar {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 9999; /* 提高z-index確保在最上層，避免與主系統navbar衝突 */
}

/* 主要內容區域，考慮到固定導航欄的高度 */
.main-content {
  flex: 1;
  padding-top: 10px;
  overflow: hidden; /* 防止內容溢出 */
}

.container {
  height: 100%;
}

.row {
  margin: 0;
  height: 100%;
}

/* 播放器容器樣式 */
.player-container {
  height: 100%;
  /* height: calc(100vh - 60px);  */
  /* 減去導航欄高度 */
  /* display: flex; */
  flex-direction: column;
  gap: 1rem;
  margin-top: 20px;
}

/* 視頻包裝器樣式 */
.video-wrapper {
  position: sticky;
  top: 10px; 
  width: 100%;
  padding-bottom: 56.25%;
  background: #000;
  overflow: hidden;
  z-index: 900;
}

/* .video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background: #000;
  overflow: hidden;
} */



/* 播放列表包裝器樣式 */
.playlist-wrapper {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
  max-height: 150px !important;
  overflow-y: auto !important; /* 確保可以滾動 */
  -webkit-overflow-scrolling: touch !important; /* 增加 iOS 滾動支持 */
  position: relative !important;
  z-index: 1000 !important; /* 設置較低的 z-index，避免覆蓋 modal */
}

/* 可滾動內容區域 */
.scrollable-content {
  height: calc(100vh - 80px);  /* 調整高度 */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 100px;
}

/* 針對 Webkit 瀏覽器（Chrome、Safari、新版 Edge）隱藏滾動條 */
.scrollable-content::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

/* 確保 router-view 內的所有組件也隱藏滾動條 */
.scrollable-content > * {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scrollable-content > *::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

/* 確保router-view中的圖片正確顯示 */
.scrollable-content img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* 響應式設計，根據不同屏幕尺寸調整間距 */
@media (max-width: 1200px) {
  .playlist-wrapper {
    margin-top: calc(56.25% - 230px);
  }
}

@media (max-width: 992px) {
  .playlist-wrapper {
    margin-top: calc(56.25% - 100px);
  }
}

@media (max-width: 768px) {
  .col-md-6 {
    width: 100%;
    height: auto;
  }
  
  .player-container {
    height: auto;
  }
  
  /* 確保整個頁面可滾動 */
  html, body, #app, .main-content {
    overflow-y: auto !important;
    height: auto !important;
    min-height: 100% !important;
  }
  
  .scrollable-content {
    height: calc(100vh - 100px);
    padding-bottom: 150px;
  }
  
  /* 調整左右列的間距 */
  .left-column {
    margin-bottom: 10px !important; /* 增加底部間距 */
  }
  
  /* 確保播放列表可滾動 */
  .playlist-wrapper {
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }
}

@media (max-width: 576px) {
  .playlist-wrapper {
    margin-top: 5px !important; /* 進一步減少頂部間距 */
    margin-bottom: 15px !important; /* 進一步減少底部間距 */
  }
  
  /* 調整視頻包裝器的底部間距 */
  .video-wrapper {
    margin-bottom: 5px !important;
  }
}

/* 超小屏幕設備進一步優化 */
@media (max-width: 480px) {
  .scrollable-content {
    height: calc(100vh - 200px);
    padding-bottom: 200px;
  }
  
  /* 調整待播歌曲區的位置 */
  .playlist-wrapper {
    margin-top: 12px !important; /* 減少頂部間距 */
    max-height: 100px !important; /* 減少最大高度 */
  }
  
  /* 調整待播歌曲標題的大小和間距 */
  .playlist-container h4 {
    margin: 0 0 5px 0 !important;
    font-size: 1rem !important;
  }
  
  /* 調整待播歌曲列表項的間距 */
  .song-list li {
    padding: 0 !important;
    margin-bottom: 0 !important;
  }
}

.main-background {
  background-image: url(/23299312_m.jpg) !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  min-height: 100vh !important;
}

/* 全局滾動設置 - 允許滾動但隱藏滾動條 */
* {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

*::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

/* 確保主要內容區域可以滾動 */
html, body, #app, .main-content {
  overflow-y: auto !important; /* 強制啟用垂直滾動 */
  height: auto !important; /* 自動高度 */
  min-height: 100% !important; /* 最小高度 */
}

/* 確保 Cookie 提示在其他元素之上 */
.cookie-consent {
  z-index: 2100 !important;  /* 確保比其他元素的 z-index 高 */
}
</style>
